import { read } from '@/api/rest';

const briefcaseUdc = {
  statsGraph: async (params) =>
    await read('/briefcase-udc/stats-graph?' + params.toString()),
  projectUdcCount: async (params) =>
    await read('/briefcase-udc/project-udc-count?' + params.toString()),
};
export default briefcaseUdc;
